import React from 'react';
import {Text} from '@flixbus/honeycomb-react';
import {ErrorSectionProps} from './ErrorSection.types';
import styles from './ErrorSection.module.scss';

const ErrorSection: React.FC<ErrorSectionProps> = ({id, title, errors}) => {
  return (
    <div key={id} data-testid={id}>
      <Text>
        <b>{title}</b>
      </Text>
      <ul>
        {errors?.map(({code, message}) => (
          <li key={code} className={styles.error}>
            {message}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default React.memo(ErrorSection);
